module.exports = __webpack_public_path__ + "img/Effective Negotiator.5390ef35.svg";